import './Contacto.css'
import ContactoForm from "../../Components/ContactoForm/ContactoForm";

const Contacto = () => {

    return (
        <div id="contenedorContacto">
            <h1>Contactanos</h1>
            <ContactoForm />
        </div>
    )
}

export default Contacto;